module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {}, [_c('div', {
    staticClass: "ddContainer row"
  }, [_c('div', {
    staticClass: "ddHeaders grid-1"
  }, [_vm._v("STORES:")]), _vm._v(" "), _c('div', {
    staticClass: "margin-reset padding-reset grid-3"
  }, [_c('dropdown', {
    attrs: {
      "id": 400,
      "list": _vm.storeLevels,
      "defaultText": _vm.selectedStoreLevelValue,
      "selectedItem": (_vm.gettersAggInputData.storeLevel) ? _vm.gettersAggInputData.storeLevel.name : ""
    },
    model: {
      value: (_vm.selectedStoreLevelValue),
      callback: function($$v) {
        _vm.selectedStoreLevelValue = $$v
      }
    }
  })], 1), _vm._v(" "), (_vm.pastOrPendingFlag === 'PAST') ? _c('span', {
    staticClass: "notification"
  }, [_vm._v("\n        Estimated figures are marked with\n        "), _c('span', {
    staticClass: "primary-green-text"
  }, [_vm._v("Green")]), _vm._v("\n        and Actual figures are marked with\n        "), _c('span', {
    staticClass: "black-text"
  }, [_vm._v("Black")]), _vm._v(".\n      ")]) : _vm._e(), _vm._v(" "), _c('div', {}, [_c('span', {
    style: ({
      'font-size': '1.3rem'
    })
  }, [_vm._v("Offer Name: ")]), _vm._v(" "), _c('span', {
    style: ({
      'padding-left': '0.5rem',
      'font-size': '1.2rem',
      'color': '#026937'
    })
  }, [_vm._v(_vm._s(_vm.gettersAggInputData.offers.name))]), _vm._v(" "), _c('span', {
    style: ({
      'padding-left': '0.5rem',
      'font-size': '1.3rem'
    })
  }, [_vm._v("Campaign Period: ")]), _vm._v(" "), _c('span', {
    style: ({
      'padding-left': '0.5rem',
      'font-size': '1.2rem',
      'color': '#026937'
    })
  }, [_vm._v(_vm._s(_vm.gettersAggInputData.period.name))])])]), _vm._v(" "), _c('div', {
    staticClass: "scrollWrapper",
    style: ({
      'margin-left': (_vm.marginLeft + "px"),
      'width': (_vm.scrollableWidth + "px"),
      'min-width': (_vm.tableContainerWidth + "px")
    }),
    attrs: {
      "id": "selectedOfferscrollWrapper"
    },
    on: {
      "scroll": _vm.topScrollContainer
    }
  }, [_c('div', {
    staticClass: "simulateScrollDiv",
    style: ({
      width: ((_vm.scrollableChildrenWidth * _vm.offersListData.length) + "rem")
    })
  })])]), _vm._v(" "), _c('div', {
    staticClass: "outer-div-min",
    attrs: {
      "id": "outer-div-min"
    }
  }, [_c('div', {
    staticClass: "inner-div",
    attrs: {
      "id": "selectedOffersInnerDiv"
    }
  }, [(_vm.hasDataToShow) ? _c('div', [_c('div', {
    staticClass: "inline-block margin-fix",
    attrs: {
      "id": "selectedOffersHeaderContainer"
    }
  }, [_c('data-table', {
    attrs: {
      "data": _vm.offersListHeaders,
      "styles": _vm.tableStyles.offersListHeaderStyles
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "scrollable-x inline-block margin-fix",
    style: ({
      width: (_vm.scrollableWidth + "px")
    }),
    attrs: {
      "id": "offersListScrollableX"
    },
    on: {
      "scroll": _vm.bottomScrollContainer
    }
  }, [_c('div', {
    staticClass: "table-container",
    style: ({
      width: ((_vm.scrollableChildrenWidth * _vm.offersListData.length - (Math.floor(Number((_vm.offersListData.length.toString()).replace(/.$/,"0")) / 2))) + "rem")
    })
  }, _vm._l((_vm.offersListData), function(data) {
    return _c('div', {
      staticClass: "inline-block margin-fix",
      class: {
        'myOfferStyle': data.my_offer, otherOfferStyle: !data.my_offer
      },
      style: ({
        width: (_vm.scrollableChildrenWidth + "rem")
      })
    }, [_c('data-table', {
      attrs: {
        "type": _vm.type,
        "handleEvent": _vm.childEvent,
        "data": data,
        "styles": _vm.tableStyles.offersListDataStyle,
        "stringPadding": _vm.offerNameStringPadding
      }
    })], 1)
  }))])]) : _c('div', {
    staticClass: "notDataPreview"
  }, [_c('h2', {
    staticClass: "grey-text"
  }, [_vm._v(_vm._s(_vm.noDataFoundText))]), _vm._v(" "), _c('button', {
    class: {
      'width_3': true, 'primary-green-bg': true
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v("\n          Back\n        ")])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-796e16f5!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/selected-offers-list/SelectedOffersList.vue
// module id = 376
// module chunks = 2